// src/features/analytics/routeApi.ts

import { getRouteApi } from '@tanstack/react-router';

// The /analytics layout route's full ID includes its non-path parents
// (protected + app-shell). Centralized so feature code never repeats it.
export const analyticsRouteApi = getRouteApi('/protected/app-shell/analytics');
